const config = window.__CONFIG_NEARPOD_NEXT || {}

export default config
